import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { simpleVehicleGroupSchema } from '../schemas/vehicle-group.schema';

/**
 * Retrieves Vehicle Groups Assigned to a Specific Map Set
 * @param id The ID of the Map Set being retrieved
 * @returns The Map Set
 */
export function getMapSetsVehicleGroups(this: unknown, id: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).mapSetsVehicleGroupsUrl(id), {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(simpleVehicleGroupSchema),
      })
    )
  );
}
